import { render } from "./WarningPopup.vue?vue&type=template&id=b675b2da"
import script from "./WarningPopup.vue?vue&type=script&lang=js"
export * from "./WarningPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__